/*Stateless common UI functions */
const MAX_FILE_SIZE_MB = 15;
const MAX_FILE_SIZE_KB = 5;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // bytes
function getFileTooLargeMessage(fileSizeMB) { return 'File is too large. Max allowed size for this free version is ' + MAX_FILE_SIZE_MB + ' MB. Your file was ' + fileSizeMB + ' MB. Send me an e-mail to let me know if this is something you really want me be develop support for.'; }

// Reusable drag-and-drop file-upload zone.
// Wires all drag-and-drop plus keyboard accessibility events for a .drop-zone
// widget that was rendered by HtmlShared.GpxDropZone().
//
// Parameters:
//   dropZoneId  - HTML id of the outer .drop-zone element (without the '#')
//   inputId     - HTML id of the hidden <input type="file"> inside the zone
//   onFileFn    - callback(file) invoked with the selected/dropped File object
//
// Returns an object with a reset() method that restores the drop zone to its
// original label text (useful when a parent modal is opened/closed).
//
// The function is idempotent: calling it twice on the same element is safe
// because it replaces event listeners rather than accumulating them.
function initGpxDropZone(dropZoneId, inputId, onFileFn) {
    var dropZone = document.getElementById(dropZoneId);
    var fileInput = document.getElementById(inputId);

    if (!dropZone || !fileInput) {
        // Drop-zone or file input not present in the current view - skip silently.
        return { reset: function () { } };
    }

    // Cache the primary label <span> and its original text so we can restore
    // it when the drop zone needs to be reset (e.g. on modal re-open).
    var labelSpan = dropZone.querySelector('span:not(.drop-zone-or)');
    var originalLabelText = labelSpan ? labelSpan.textContent : null;

    // Updates the drop zone label to show the selected filename and adds
    // a 'file-selected' CSS class, then delegates to the caller's callback.
    function processFile(file) {
        if (labelSpan) {
            labelSpan.textContent = '\u2713 ' + file.name;
        }
        dropZone.classList.add('file-selected');
        onFileFn(file);
    }

    // Restores the drop zone to its original appearance.
    // Call this whenever the containing form or modal is reset/reopened.
    function resetDropZone() {
        if (labelSpan && originalLabelText !== null) {
            labelSpan.textContent = originalLabelText;
        }
        dropZone.classList.remove('file-selected');
        dropZone.classList.remove('drag-over');
    }

    // Clicking anywhere on the zone (except labels) opens the file dialog.
    dropZone.addEventListener('click', function (e) {
        // The <label for="inputId"> already triggers the input natively via the browser;
        // guard against double-opening when the originating element is the label itself.
        if (e.target.tagName !== 'LABEL') {
            fileInput.click();
        }
    });

    // Keyboard activation (Enter / Space) for screen-reader accessibility.
    dropZone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fileInput.click();
        }
    });

    // Visual feedback while a file is being dragged over the zone.
    dropZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.add('drag-over');
    });

    dropZone.addEventListener('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.remove('drag-over');
    });

    // Handle the actual file drop - show filename and invoke callback.
    dropZone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.remove('drag-over');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) {
            processFile(file);
        }
    });

    // Native file-input change (user picked via dialog) - show filename and invoke callback.
    fileInput.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        if (file) {
            processFile(file);
        }
        // Clear the input so the same file can be re-selected after an error
        fileInput.value = '';
    });

    // Expose reset so callers can restore the drop zone label when needed.
    return { reset: resetDropZone };
}

function getBrowserTimezoneOffset() {
    // Returns the browser's timezone offset in minutes, e.g. -60 for GMT+1
    // This is the opposite of what JavaScript's Date.getTimezoneOffset() returns.
    return -new Date().getTimezoneOffset();
}
const browserTimezoneOffset = getBrowserTimezoneOffset();

var fullScreenMode = false;

function textToNumberOrNull(text) {
    if (text === "")
        return null;
    const num = Number(text);
    return Number.isFinite(num) ? num : null;
}

var fullScreenMode = false;

function textToNumberOrNull(text) {
    if (text === "")
        return null;
    const num = Number(text);
    return Number.isFinite(num) ? num : null;
}

var time_from_string = function (str) {
    debug('time_from_string');
    var hours = 0, minutes = 0, seconds = 0;
    var hMatch = str.match(/(\d+)\s*h/);
    var mMatch = str.match(/(\d+)\s*m/);
    var sMatch = str.match(/(\d+)\s*s/);
    if (hMatch) hours = parseInt(hMatch[1], 10);
    if (mMatch) minutes = parseInt(mMatch[1], 10);
    if (sMatch) seconds = parseInt(sMatch[1], 10);
    return hours * 3600 + minutes * 60 + seconds;
};

var distance_from_string = function (str) {
    debug('distance_from_string');
    var match = str.match(/([\d.]+)/);
    if (!match) return 0;
    var km = parseFloat(match[1]);
    return Math.round(km * 1000);
};

// Helper functions for table sorting
var date_from_string = function (str) {
    var parts = str.split(' ');
    var datePart = parts[0];
    var timePart = parts[1];
    var d = datePart.split('.');
    var day = parseInt(d[0], 10);
    var month = parseInt(d[1], 10) - 1; // JS months are 0-based
    var year = parseInt(d[2], 10);
    var t = timePart.split(':');
    var hour = parseInt(t[0], 10);
    var min = parseInt(t[1], 10);
    var sec = parseInt(t[2], 10);
    return new Date(year, month, day, hour, min, sec);
};

var stupidTableSortFunctions = {
    'date': function (a, b) {
        return date_from_string(a) - date_from_string(b);
    },
    'time': function (a, b) {
        return time_from_string(a) - time_from_string(b);
    },
    'distance': function (a, b) {
        return distance_from_string(a) - distance_from_string(b);
    }
};
function scrollToBottomMessage() {
    debug('scrollToBottomMessage');
    const messageBottom = $("#action-panels");   
    const elementTop = messageBottom.offset().top+40;
    debug('elementTop=' + elementTop);
    let elementBottom = elementTop + messageBottom.outerHeight();
    if (elementBottom < 50)
        elementBottom = 50;
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    if (elementTop < viewportTop) {
        // Element is above viewport - scroll up just enough to show it at top
        $([document.documentElement, document.body]).animate({
            scrollTop: elementTop
        }, 90);
    } else if (elementBottom > viewportBottom) {
        // Element is below viewport - scroll down just enough to show it at bottom
        $([document.documentElement, document.body]).animate({
            scrollTop: elementBottom - $(window).height()
        }, 220);
    }
}
function showUploadFileMessage() {
    $('#download-area').hide();
    scrollToBottomMessage();
    showError('Please first select a workout/activity.');
}
function showError(message, additionalInfo) {
    showMessage(message, additionalInfo, 'error');
}

function showMessage(message, additionalInfo, messageClass) {
    $('#message-bottom').css('opacity', 0);
    $('#message-bottom').show();
    const additionalContent = additionalInfo ? `<br/>${additionalInfo}` : '';
    $('#message-bottom').html(`<span class='${messageClass}'>${message}</span>${additionalContent}`).show();
    $('#message-bottom').fadeTo(200, 1);
    hideLoaders();
}

function hideAllPanels() {
    $('.action-panel').hide();
    if (window.state) {
        window.state.editMode = false;
        if (window.state.polyline && window.state.polyline.disableEdit) {
            window.state.polyline.disableEdit();
        }
    }
    $('#file-combine').val('');
    //$('#file-input').val('');
    // Disable bad HR segment selection when panels close
    if (window.GpxFixChart && window.GpxFixChart.disableBadSegmentSelection && window.state && window.state.chart) {
        window.GpxFixChart.disableBadSegmentSelection(window.state.chart);
        window.GpxFixChart.clearBadSegments(window.state.chart);
    }
    // Disable crop range selection when panels close
    if (window.GpxFixChart && window.GpxFixChart.disableCropRangeSelection && window.state && window.state.chart) {
        window.GpxFixChart.disableCropRangeSelection(window.state.chart);
    }
    $('#btn-crop-select-chart').text('Select on chart').removeClass('active');
    $('#crop-chart-selection-label').text('');
    // Disable waypoint edit mode
    if (window.gpxFixState) {
        if (window.gpxFixState.waypointEditMode && window.gpxFixState.map) {
            window.gpxFixState.map.off('click');
        }
        window.gpxFixState.waypointEditMode = false;
        window.gpxFixState.pendingWaypointChanges = [];
    }
    $('#waypoint-add-form').hide();
}

function getBrowserTimezoneOffset() {
    const currentDate = new Date();
    const offsetInMinutes = currentDate.getTimezoneOffset();
    return offsetInMinutes / 60;
}

function showSuccess(message, additionalInfo) {
    showMessage(message, additionalInfo, 'success');
}


function formatTime(dateval, showDate, showFractionalSeconds) {
    const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' };
    const timeOptions = useImperial ? { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true } : { hour: '2-digit', minute: '2-digit', second: '2-digit' };
    if (showFractionalSeconds && dateval.getMilliseconds && dateval.getMilliseconds() > 0) {
        timeOptions.fractionalSecondDigits = 1;
    }
    const formattedDate = dateval.toLocaleDateString(undefined, dateOptions);
    const formattedTime = dateval.toLocaleTimeString(undefined, timeOptions);
    return showDate ? (formattedDate + ' ' + formattedTime) : formattedTime;
}

function formatPointPreviewInfo(idx, cnt, startTime, time, hr, ele, speed, cadence, power, distanceMeters) {    
    let validTime = time != null && time.getFullYear() > 1975;
    let info = `<div><span><strong>Point</strong> ${idx + 1}/${cnt}`;
    if (validTime) info += ` <strong>Time of day</strong> ${formatTime(time, false, true)}`;
    info += '</span>';
    if (startTime && validTime) info += ` <span class="right"><strong>Elapsed</strong> ${formatTimeSpanBetween(startTime, time, true)}</span>`;

    info += '</div><div style="display:flex;align-items:center;flex-wrap:wrap"><div>';
    if (distanceMeters !== null && distanceMeters !== undefined) info += ` <strong>Distance</strong> ${formatDistance(distanceMeters, useImperial)}`;
    if (hr) info += ` <strong>HR</strong> ${hr} bpm`;
    if (ele !== null && ele !== undefined) info += ` <strong>Elevation</strong> ${Math.round(ele)} m`;

    if (speed!==null) info += ` <strong>Speed</strong> ${useImperial ? (speed * 0.621371).toFixed(1) + ' mph' : speed.toFixed(1) + ' km/h'}`;
    if (cadence) info += ` <strong>Cadence</strong> ${cadence.toFixed(0)} rpm`;
    if (power) info += ` <strong>Power</strong> ${power} W`;
    info += '</div><div id="incline-indicator" style="margin-left:auto"></div></div>';
    return info;
}

function addHours(date, hours) {
    const newDate = new Date(date); // Create a copy to avoid mutating the original date
    newDate.setHours(newDate.getHours() + hours);
    return newDate;
}

function debug(msg) {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.log(msg);
    }
}

function showPanel(panelId) {
    hideAllPanels();
    $('#message-bottom').text('');

    // Special handling for fixhr - show the input panel first
    const actualPanelId = panelId === 'fixhr' ? 'fixhr-input' : panelId;
    const $panel = $('#panel-' + actualPanelId);
    $panel.show();

    if (panelId === 'fixhr') {
        debug('cvlicked');
        $('input[name="radioHrIssue"]').first().prop('checked', true).trigger('change');
    }

    // Populate current track points for resample panel
    if (panelId === 'resample') {
        const currentPoints = window.gpxFixState.summary?.coordinatesCount || window.gpxFixState.coordinates?.length || 0;
        $('#current-trackpoints').text(currentPoints);
        $('#input-target-trackpoints').val(Math.round(currentPoints / 2)); // Default to half
    }

    // Sync the 'All' master checkbox with the individual checkboxes on open
    if (panelId === 'strip') {
        var allChecked = ['#strip-hr', '#strip-cadence', '#strip-power', '#strip-time', '#strip-metadata'].every(function (id) { return document.querySelector(id) && document.querySelector(id).checked; });
        var allBox = document.getElementById('strip-all');
        if (allBox) allBox.checked = allChecked;
    }

    // Check if close button already exists, if not add one
    if ($panel.find('.btn-close-panel').length === 0) {
        const $closeBtn = $('<button type="button" class="btn-close-panel" title="Close">&times;</button>');
        $closeBtn.css({
            'position': 'absolute',
            'top': '5px',
            'right': '5px',
            'background': 'transparent',
            'border': 'none',
            'font-size': '20px',
            'cursor': 'pointer',
            'line-height': '1'
        });
        $closeBtn.on('click', function () {
            hideAllPanels();
        });
        // Ensure panel has relative positioning for absolute child
        if ($panel.css('position') === 'static') {
            $panel.css('position', 'relative');
        }
        $panel.prepend($closeBtn);
    }
    $(document).trigger('panelShown', [panelId]);
}

function showLoader(id) {
    debug('showLoader:' + id);
    if (!id) { 
        $('#message-bottom').text('');
        $('#message-bottom').show();
        $('#message-bottom').css('opacity', 1);
        $('#message-bottom').html('<div class="loader"></div>');
    }else { 
        $('#' + id).show();
    }
}

function formatTimeSpanFromSeconds(totalSeconds, showFractionalSeconds) {
    if (totalSeconds === null || totalSeconds === undefined || isNaN(totalSeconds)) {
        return '';
    }
    const negative = totalSeconds < 0;
    const abs = Math.abs(totalSeconds);
    const seconds = showFractionalSeconds ? Math.round((abs % 60) * 10) / 10 : Math.round(abs % 60);
    const totalMinutes = Math.floor(abs / 60);
    const minutes = totalMinutes % 60;
    const totalHours = Math.floor(totalMinutes / 60);
    const hours = totalHours % 24;
    const days = Math.floor(totalHours / 24);
    let parts = [];
    if (days > 0) parts.push(days + 'd');
    if (hours > 0 || days > 0) parts.push(hours + 'h');
    if (minutes > 0 || hours > 0 || days > 0) parts.push(minutes + 'm');
    parts.push(seconds + 's');
    return (negative ? '-' : '') + parts.join(' ');
}

function formatTimeSpanBetween(startTime, endTime, showFractionalSeconds) {
    const start = typeof startTime === 'number' ? startTime : Date.parse(startTime);
    const end = typeof endTime === 'number' ? endTime : Date.parse(endTime);
    if (isNaN(start) || isNaN(end)) return '';
    const totalSeconds = (end - start) / 1000;
    return formatTimeSpanFromSeconds(totalSeconds, showFractionalSeconds);
}

function formatDistance(meters, useImperial) {
    if (meters === null || meters === undefined || isNaN(meters)) {
        return '';
    }
    useImperial = useImperial || false;
    if (useImperial) {
        const miles = meters / 1609.344;
        return miles.toFixed(2) + ' mi';
    }
    if (meters >= 1000) {
        return (meters / 1000).toFixed(2) + ' km';
    }
    return Math.round(meters) + ' m';
}

function formatSpeed(speedKmh, useImperial) {
    if (speedKmh === null || speedKmh === undefined || isNaN(speedKmh)) {
        return '';
    }
    useImperial = useImperial || false;
    if (useImperial) {
        const mph = speedKmh * 0.621371;
        return mph.toFixed(1) + ' mph';
    }
    return speedKmh.toFixed(1) + ' km/h';
}

function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function formatPace(speedKmh) {
    if (!speedKmh || speedKmh <= 0) return '';
    if (useImperial) {
        const speedMph = speedKmh * 0.621371;
        const paceMinPerMile = 60 / speedMph;
        const paceMin = Math.floor(paceMinPerMile);
        const paceSec = Math.round((paceMinPerMile - paceMin) * 60);
        return paceMin + ':' + paceSec.toString().padStart(2, '0') + ' min/mi';
    }
    const paceMinPerKm = 60 / speedKmh;
    const paceMin = Math.floor(paceMinPerKm);
    const paceSec = Math.round((paceMinPerKm - paceMin) * 60);
    return paceMin + ':' + paceSec.toString().padStart(2, '0') + ' min/km';
}

function hideLoaders() {
    $('.loader').hide();
}

function generateDownload() {
    if ($('#gpx')) {
        const content = $('#gpx').val();
        const downloadLink = document.getElementById('downloadLink');
        if (downloadLink) {
            const fileName = $('#fileName').val();
            const blob = new Blob([content], { type: 'application/gpx+xml; charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const fileParts = fileName.split('.');
            let editedFileName;
            if (fileParts.length > 1) {
                const ext = fileParts.pop();
                editedFileName = fileParts.join('.') + '_updated' + '.' + ext;
            } else {
                if (fileName.length < 1) {
                    editedFileName = encodeURI($('#activityName').val().replace(/ /g, '_')) + '.gpx';
                } else {
                    editedFileName = fileName + '_updated.gpx';
                }
            }
            downloadLink.href = url;
            downloadLink.download = editedFileName;
            downloadLink.style.display = 'inline';
        }
    }
}







function calculateTotal(items) {
    return items.reduce((sum, item) => {
        return sum + item.price;
    }, 0);
}
function processOrder(order) {
    const total = calculateTotal(order.items);
    console.log("Total:", total);

    // Intentional error
    const customerName = order.customer.name.first.toUpperCase();

    return customerName;
}
function startCrashTest() {
    const order = {
        items: [
            { price: 10 },
            { price: 20 }
        ],

        // customer intentionally missing
    };

    processOrder(order);
}













function blinkBackground($el, times = 2, interval = 150) {
    let count = 0;
    const timerBlink = setInterval(() => {
        $el.toggleClass("blink-bg");
        count++;
        if (count >= times * 2) {
            clearInterval(timerBlink);
            $el.removeClass("blink-bg");
        }
    }, interval);
}

function bindTooltips() {
    var tooltipIsVisible = false;
    $('.help-icon').off('mouseenter mouseleave').on('mouseenter', function (e) {
        debug('help icon over');
        e.stopPropagation();
        // Close any open tooltips
        $('.tooltip-box').remove();
        var tooltipText = $(this).data('tooltip');
        var tooltip = $('<div class="tooltip-box"></div>').html(tooltipText);
        $(this).append(tooltip);
        tooltipIsVisible = true;
        tooltip.fadeIn(200);
    }).on('mouseleave', function (e) {
        $('.tooltip-box').remove();
        tooltipIsVisible = false;
    });
}

$(document).ready(function () {
    $('.btn-exit-panel').on('click', function () {
        $('#message-bottom').text('');
        hideAllPanels();
    });

    if ($('.error').length > 0) {
        blinkBackground($(".error"), 2);
    }

    $('#btMenuChangeDate').on('click', function (e) {
        const localDateTime = new Date(now.getTime() - offset * 60000).toISOString().slice(0, 16);
        document.getElementById('input-newdate').max = localDateTime;
        // Reset panel to 'change start time' mode so it always opens clean
        $('input[name="changeDateMode"][value="starttime"]').prop('checked', true);
        $('#panel-changedate-start').show();
        $('#panel-changedate-atpoint').hide();
    });

    $('input[name="radioRestoreGpsFrom"]').on('change', function () {
        var selectedValue = $('input[name="radioRestoreGpsFrom"]:checked').val();
        $('#divRestoreGpsFromSelf').hide();
        $('#divRestoreGpsFromOther').hide();
        $('#divRestoreGpsFromIndoor').hide();
        if (selectedValue == 'route') {
            $('#divRestoreGpsFromSelf').show();
        } else if (selectedValue == 'indoor') {
            $('#divRestoreGpsFromIndoor').show();
        } else {
            $('#divRestoreGpsFromOther').show();
        }
    });

    $('input[name="radioMenuSection"]').on('change', function () {
        var selectedValue = $('input[name="radioMenuSection"]:checked').val();
        $('ul#menu li').hide();
        if (selectedValue == 'all') {
            $('ul#menu li').show();
        } else {
            $('ul#menu li.cat-' + selectedValue).show();
        }
    });

    $('#submitNewDateButton').click(function (e) {
        if ($('#date').val()) {
            showLoader();
            $('#fileUploadForm').attr('action', 'changedate');
        } else {
            $('#msgBottom').html('<p class=\'error\'>Please choose new date and time.</p>').show().delay(2000).fadeOut('slow');
            e.preventDefault();
        }
    });

    $('#btnSaveToStrava').click(function (e) {
        e.preventDefault();
        $('#action-result-message').html('<div class="loader" style="height:16px;width:16px"></div>');
        const gpxData = $('#gpx').val();
        const commute = $('#commute').val();
        const trainer = $('#trainer').val();
        const hideFromHome = $('#hideFromHome').val();
        const gear = $('#gear').val();
        const name = $('#activityName').val();
        const description = $('#activityDesc').val();
        const activityId = $('#stravaActivityId').val();
        const isPrivate = $('#private').val();
        const sportType = $('#sportType').val();

        let activityIdParam = '';
        if (activityId.indexOf(']]') < 0) {
            activityIdParam = '?activityId=' + activityId;
        }
        let postData = {
            commute: commute.indexOf(']]') < 0 ? (commute === 'True') : '',
            trainer: trainer.indexOf(']]') < 0 ? (trainer === 'True') : '',
            gear: gear.indexOf(']]') < 0 ? gear : '',
            hideFromHome: hideFromHome.indexOf(']]') < 0 ? (hideFromHome === 'True') : '',
            private: isPrivate.indexOf(']]') < 0 ? (isPrivate === 'True') : '',
            name: name,
            description: description,
            sport_type: sportType,
            gpx: gpxData
        };

        $.ajax({
            url: 'api/activity/save' + activityIdParam,
            method: 'POST',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify(postData),
            success: function (data) {
                console.error('data:', data);
                if (data.statuscode == -1) {
                    // $.toast({ text: data.message,hideAfter: 39000, position: 'top-right',loaderBg: '#0D5578'});
                    $('#action-result-message').html(data.message);
                } else {
                    // $.toast({ text: data.message,hideAfter: 34000, position: 'top-right',loaderBg: '#0D5578'});
                    $('#action-result-message').html(data.message);
                }
            },
            error: function (xhr, status, error) {
                console.error('API call failed:', error);
                $('#action-result-message').html(xhr.responseJSON.message);
            }
        });
    });

    $('.submitHr').click(function (e) {
        showLoader();
        $('#fileUploadForm').attr('action', 'fixhr');
        $('#fixHrCorrectTo').val($(this).data('group'));
        $('#fileUploadForm').submit();
    });
    $('#cancelHrFix').click(function (e) {
        $('#fixHrConfirm').hide();
        e.preventDefault();
    });

    $('#submitElevationCalibrationButton').on('click', function (e) {
        let elevAdd = $('#input-ele-add').val();
        let elevMin = $('#input-ele-min').val();
        let elevMax = $('#input-ele-max').val();

        // Validate elevationCalibrationAdd if provided
        if (elevAdd && elevAdd.trim() !== '') {
            if (!/^[-+]?\d*\.?\d+$/.test(elevAdd)) {
                showError('Please enter a valid number for elevation to add/remove.');
                e.preventDefault();
                return;
            }
            if (parseFloat(elevAdd) > 100 || parseFloat(elevAdd) < -100 || parseFloat(elevAdd) == 0) {
                showError('Elevation to add/remove must be a number between -100 and 100 or blank.');
                e.preventDefault();
                return;
            }
        }

        // Validate elevationCalibrationMin if provided
        if (elevMin && elevMin.trim() !== '') {
            if (!/^[-+]?\d*\.?\d+$/.test(elevMin)) {
                showError('Please enter a valid number for min elevation.');
                e.preventDefault();
                return;
            }
            if (parseFloat(elevMin) < -500 || parseFloat(elevMin) > 8000) {
                showError('Min elevation must be between -500 and 8000 or blank.');
                e.preventDefault();
                return;
            }
        }

        // Validate elevationCalibrationMax if provided
        if (elevMax && elevMax.trim() !== '') {
            if (!/^[-+]?\d*\.?\d+$/.test(elevMax)) {
                showError('Please enter a valid number for max elevation.');
                e.preventDefault();
                return;
            }
            if (parseFloat(elevMax) < -500 || parseFloat(elevMax) > 8000) {
                showError('Max elevation must be between -500 and 8000 or blank.');
                e.preventDefault();
                return;
            }
        }

        // Validate min is less than max if both are provided
        if (elevMin && elevMin.trim() !== '' && elevMax && elevMax.trim() !== '') {
            if (parseFloat(elevMin) >= parseFloat(elevMax)) {
                showError('Min elevation must be less than max elevation.');
                e.preventDefault();
                return;
            }
        }

        // Ensure at least one field is filled
        if ((!elevAdd || elevAdd.trim() === '') && (!elevMin || elevMin.trim() === '') && (!elevMax || elevMax.trim() === '')) {
            showError('Please enter at least one elevation calibration value.');
            e.preventDefault();
            return;
        }

        showLoader();
    });

    $('#connectStrava').on('click', function () {
        $('#loader').show();
    });

    $('#btn-updatedistance').on('click', function (e) {
        let meters = $('#input-meters-add').val();
        if (!/^[-+]?\d*\.?\d+$/.test(meters)) {
            showError('Please enter a valid positive number.');
            e.preventDefault();
            return;
        }
        if (meters < -100 || meters > 100 || meters == 0) {
            showError('Please enter a non zero number between -100 and 100.');
            e.preventDefault();
            return;
        }
        showLoader();
    });



    $('#file2').change(function (e) {
        const fileInput = document.getElementById('file2');
        const file = fileInput.files[0];
        if (file && file.size > MAX_FILE_SIZE) {
            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(1);
            e.preventDefault();
            showError(getFileTooLargeMessage(fileSizeMB));
            fileInput.value = '';
            return;
        }
        showLoader();
    });

    $('#fileCompare').change(function (e) {
        const fileInput = document.getElementById('fileCompare');
        const file = fileInput.files[0];
        if (file && file.size > MAX_FILE_SIZE) {
            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(1);
            e.preventDefault();
            showError(getFileTooLargeMessage(fileSizeMB));
            fileInput.value = '';
            return;
        } else if (file && file.size < 1000) {
            e.preventDefault();
            showError("Not a valid GPX file.");
            fileInput.value = '';
            return;
        }
        showLoader();
    });

    $('#fileRestoreGps').change(function (e) {
        const fileInput = document.getElementById('fileRestoreGps');
        const file = fileInput.files[0];
        if (file && file.size > MAX_FILE_SIZE) {
            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(1);
            e.preventDefault();
            showError(getFileTooLargeMessage(fileSizeMB));
            fileInput.value = '';
            return;
        }
        showLoader();
    });

    bindTooltips();

    var now = new Date();
    var offset = now.getTimezoneOffset();
    $('#timezone').val(offset);


    if ($(window).width() < 600) {
        var $link = $("#stravalink");
        $link.replaceWith($link.text());
    }
    $('.utcTime').each(function () {
        const utc = $(this).data('utc');
        if (utc) {
            const date = new Date(utc);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const formatted = `${year}-${month}-${day} ${hours}:${minutes}`;
            //const formatted = localDate.toLocaleString(); // or .toLocaleDateString(), etc.
            $(this).text(formatted);
        }
    });


    $('#btn-fullscreen').on('click', function (e) {
        const state = window.gpxFixState;
        e.preventDefault();
        $('#map-outer').hide();
        $('#btn-fullscreen').hide();
        $('#popupParagraphContainer').append($('#map-outer'));
        $('#flyover').addClass('open');
        let wh = $(window).height();
        $('#map').height((((wh - 300) * 7) / 10).toFixed(0));
        $('#chart').parent().height(300);
        state.chart.height = 300;
        state.chart.update(); // Redraws the chart
        fullScreenMode = true;
        $('#map-outer').show();
        state.map.invalidateSize();
    });

    $('#closePopup').on('click', function () {
        const state = window.gpxFixState;
        $('#map-outer').hide();
        $('#flyover').after($('#map-outer'));
        $('#map').height(300);
        fullScreenMode = false;
        $('#chart').parent().height(140);
        $('#flyover').removeClass('open');
        state.chart.resize(); // Forces the chart to recalculate its size
        state.chart.update(); // Redraws the chart
        $('#map-outer').show();
        $('#btn-fullscreen').show();
        state.map.invalidateSize();
    });

    // clicking outside popup closes it
    $(document).on('click', function (e) {
        if (!$(e.target).closest('#flyover, #btn-fullscreen').length) {
            if ($('#flyover').hasClass('open')) {
                $('#map-outer').hide();
                $('#flyover').after($('#map-outer'));
                $('#map').height(300);
                fullScreenMode = false;
                $('#chart').parent().height(140);
                $('#flyover').removeClass('open');
                const state = window.gpxFixState;
                state.chart.resize(); // Forces the chart to recalculate its size
                state.chart.update(); // Redraws the chart
                $('#map-outer').show();
                $('#btn-fullscreen').show();
                state.map.invalidateSize();
            }
        }
    });

    // ---------------------------------------------------------------
    // Donation popup logic
    // Tracks how many operations the user has completed this calendar
    // month.  Once the threshold is reached and the popup has not been
    // dismissed for this month, it is displayed automatically.
    // ---------------------------------------------------------------

    /**
     * Returns a string key for the current year+month, e.g. "2024-06".
     * Used to namespace localStorage entries so dismissal resets each month.
     */
    function getDonateMonthKey() {
        var now = new Date();
        return 'donate_' + now.getFullYear() + '_' + (now.getMonth() + 1);
    }

    /**
     * Increments the operation counter for the current month in localStorage
     * and shows the donation popup when the threshold of 5 operations is reached,
     * provided the user has not already dismissed it this month.
     */
    window.trackOperationForDonation = function () {
        var monthKey = getDonateMonthKey();
        var dismissedKey = monthKey + '_dismissed';
        var downloadKey = monthKey + '_downloaded';

        // If the user already dismissed the popup this month, do nothing.
        if (localStorage.getItem(dismissedKey)) {
            return;
        }

        // Increment the monthly operation counter.
        var count = parseInt(localStorage.getItem(monthKey) || '0', 10) + 1;
        localStorage.setItem(monthKey, String(count));

        // Show the popup once the threshold is reached and they have downloaded at least once.
        var threshold = 10;
        let hasDownloaded = localStorage.getItem(downloadKey);
        debug("count=" + count + " hasDownloaded=" + hasDownloaded);
         
        if (count >= threshold && hasDownloaded) {
            showDonatePopup();
        }
    };

    /**
     * Opens the donation popup overlay after a 4-second delay to avoid
     * interfering with other UI updates.
     */
    function showDonatePopup() {
        setTimeout(function() {
            $('#donate-popup-overlay').addClass('open');
        }, 4000);
    }

    /**
     * Closes the donation popup overlay and records the dismissal in
     * localStorage so it does not reappear for the rest of the month.
     */
    function closeDonatePopup() {
        $('#donate-popup-overlay').removeClass('open');
        var dismissedKey = getDonateMonthKey() + '_dismissed';
        localStorage.setItem(dismissedKey, '1');
    }

    // Close when the user clicks the � button in the top-right corner.
    $('#btn-donate-close-x').on('click', function () {
        closeDonatePopup();
    });

    // Close when the user clicks the 'Close' button.
    $('#btn-donate-close').on('click', function () {
        closeDonatePopup();
    });

    // Close (and mark as donated) when the user clicks 'Already donated'.
    $('#btn-donate-already').on('click', function () {
        closeDonatePopup();
    });
    $('#btn-donate-cancel').on('click', function () {
        closeDonatePopup();
    });

    // When the user clicks the download link, record it for the donation popup logic.
    // NOTE: The element id is 'download-link' (defined in HtmlSpa.cs), not 'downloadLink'.
    $('#download-link').on('click', function () {
        var downloadKey = getDonateMonthKey() + '_downloaded';
        localStorage.setItem(downloadKey, '1');
    });

});
